import React from 'react';
import {Tooltip, Whisper} from 'rsuite';
import {getSummaryCounterData} from '../../functions/functions';

const SummaryRow = ({columnsList, formData, gridWidths, topLevelFormData, setTopLevelFormData}) => {

    let currentGridWidth = -2;
    let currentGridWidthUpdatePrice = -2;

    const renderSummaryCounter = (key, column) => {
        const summary = getSummaryCounterData(formData, key, column);

        if (!summary.isChoice) {
            return summary.count;
        }

        return (
            <>
                <span className="summary-counter-labels">
                    {summary.visibleLabels.map(({text}, index) => (
                        <React.Fragment key={text}>
                            {index > 0 && <br />}
                            {text}
                        </React.Fragment>
                    ))}
                </span>
                {summary.hiddenLabels.length > 0 && (
                    <>
                        <br />
                        <Whisper
                            trigger={['hover', 'focus']}
                            placement="top"
                            speaker={
                                <Tooltip>
                                    {summary.hiddenLabels.map(({text}) => (
                                        <div key={text}>{text}</div>
                                    ))}
                                </Tooltip>
                            }
                        >
                            <button
                                type="button"
                                className="summary-counter-more"
                                aria-label={`Weitere ${summary.hiddenLabels.length} Werte anzeigen`}
                            >
                                +{summary.hiddenLabels.length}
                            </button>
                        </Whisper>
                    </>
                )}
            </>
        );
    };

    return (
        <>
            <tr className="summary">
                {columnsList.filter(e => !e.hidden).map(
                    (col, i) => {

                        const {
                            key,
                            sticky,
                            hideFooterCount,
                        } = col;

                        const style = {
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'sticky',
                            bottom: '0',
                            background: 'white',
                            fontSize: '12px',
                            zIndex: 100,
                        };

                        if (i == 2) {
                            style['gridColumn'] = 'span 2';
                        } else if (i == 3) {
                            return null;
                        }

                        if (sticky) {
                            style['left'] = currentGridWidthUpdatePrice + 'px';
                            currentGridWidthUpdatePrice = parseInt(gridWidths[i]) + currentGridWidthUpdatePrice;
                        }

                        return (
                            <td
                                key={key + i}
                                style={style}
                                className={`${
                                    sticky ? 'isSticky footerSticky' : ''
                                } `}
                            >
                                {i == 2 ? <span style={{padding: '5px'}}>Preise & Zuschläge aktualisieren</span> : null}

                                {col.property.startsWith('order_item_') ? <>

                                    <input
                                        type={"checkbox"}
                                        checked={topLevelFormData?.[col.property + '_update_price']}
                                        className="form-control"
                                        onChange={(e) => {

                                            setTopLevelFormData({
                                                ...topLevelFormData,
                                                [col.property + '_update_price']: e.currentTarget.checked
                                            });
                                        }}
                                    />

                                </> : null}
                            </td>
                        );
                    }
                )}
            </tr>
            <tr className="summary">
                {columnsList.filter(e => !e.hidden).map(
                    (col, i) => {

                        const {
                            key,
                            sticky,
                            hideFooterCount,
                        } = col;

                        const style = {
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'sticky',
                            bottom: '0',
                            background: 'white',
                            fontSize: '12px',
                            zIndex: 100,
                        };

                        if (sticky) {
                            style['left'] = currentGridWidth + 'px';
                            currentGridWidth = parseInt(gridWidths[i]) + currentGridWidth;
                        }

                        return (
                            <td
                                key={key + i}
                                style={style}
                                className={`sticky-order-summary ${
                                    sticky ? 'isSticky footerSticky' : ''
                                } `}
                            >
                                {!hideFooterCount
                                    ? renderSummaryCounter(key, col)
                                    : null}
                            </td>
                        );
                    }
                )}
            </tr>
        </>
    );
};

export default SummaryRow;
